import { loader } from 'graphql.macro'

export default function asset ({ dataLoaders, queryKey }) {
  const [, id] = queryKey
  const assetSchema = loader('./asset.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(assetSchema, { id })
}
